import { IPostGeneralStocksResult } from '@/fsd/entities/remains/model/types/IPostGeneralStocksResult';
import TableItem from '@/fsd/entities/table/ui/TableItem/TableItem';
import BodyTableLine from '@/fsd/shared/ui/BodyTableLine';
import BodyTableLineItem from '@/fsd/shared/ui/BodyTableLineItem';
import { observer } from 'mobx-react-lite';
import RemainsStore from '../../model/store/RemainsStore';
import { RemainsTableTotalRow } from './RemainsTableTotalRow/RemainsTableTotalRow';

interface IProps {
  data: IPostGeneralStocksResult;
}

const RemainsTableBody = observer(({ data }: IProps) => {
  const { columns } = RemainsStore;


  return (
    <>
      {data?.items.map((row) => (
        <BodyTableLine key={row.product_id}>
          {columns.map((column) =>
            column.isVisible ? (
              <BodyTableLineItem
                key={column.id}
                value={<TableItem column={column} item={row} />}
                style={{ width: `${column.width}px` }}
              />
            ) : null
          )}
        </BodyTableLine>
      ))}
      <RemainsTableTotalRow data={data} />
    </>
  );
});

export default RemainsTableBody;
